<!-- Global Hero Section -->
<header class="hero-section-global">
  <div class="hero-background-global"
    style="background-image: url('//images.ctfassets.net/f6ou4743hwzs/2xaL3IYyS5iU8bcXoWAOdX/9d1784950839614bbbcaa593c23ee090/whyblm.jpg'); background-position: center 30%;">
  </div>
  <div class="hero-overlay-global"></div>
  <div class="hero-content-global">
    <h1 class="hero-title-global">Current Exhibits</h1>
    <p class="lead"
      style="color: rgba(255,255,255,0.9); border: none; background: none; text-shadow: 0 2px 4px rgba(0,0,0,0.5);">
      Explore the rich history and culture of Lacombe
    </p>
  </div>
</header>

<div class="container">
  <!-- <div class="header-section"> ... removed ... </div> -->

  <div class="exhibits-gallery">
    <div class="exhibit-card" *ngFor="let be of exhibits" [routerLink]="['/exhibits', be.fields.url]">
      <div class="card-image" [style.background-image]="'url('+be.fields.image.fields.file.url+')'">
        <div class="card-overlay">
          <div class="card-content">
            <span class="explore-tag">Explore</span>
            <h2 [innerHTML]="be.fields.title | mdToHtml"></h2>
            <div class="card-divider"></div>
            <button mat-flat-button class="view-exhibit-btn" aria-label="Explore exhibit details">
              <span>View Exhibit Details</span>
              <mat-icon class="btn-arrow">arrow_forward</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>